import { useSelector } from "react-redux";

interface CategoryItem {
    url: string;
    category: any;
    subCategories?: CategoryItem[];
}

export default (): CategoryItem[] => {
    const categoriesObj: Record<string, any> = useSelector<any, Record<string, any>>((state) => state.catalog?.categories);
    const result: CategoryItem[] = [];

    if (categoriesObj) {
        // Main Categories
        for (const key in categoriesObj) {
            const category = categoriesObj[key];

            if (!category.result.category.parentId) {
                result.push({
                    url: key,
                    category: category.result.category,
                });
            }
        }

        // Sub Categories
        for (const key in categoriesObj) {
            const category = categoriesObj[key];

            if (category.result.category.parentId) {
                const mainCategory = result.find((x) => x.category.id === category.result.category.parentId);

                if (mainCategory) {
                    mainCategory["subCategories"] = mainCategory["subCategories"] ?? [];
                    mainCategory["subCategories"].push({
                        url: key,
                        category: category.result.category,
                    });
                }
            }
        }
    }

    return result;
};
